// selectStyles.js
// SDS-local copy of V5's compact filterSelectStyles (v4's delSelect version renders taller)

export const filterSelectStyles = () => ({
  container: (base) => ({ ...base, width: "100%" }),
  control: (provided) => ({
    ...provided,
    border: "1px solid #ddd",
    borderRadius: "4px",
    minHeight: "26px",
    height: "26px",
    boxSizing: "border-box",
    padding: 0,
    fontSize: "0.75rem",
    backgroundColor: "white",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 6px",
    height: "26px",
  }),
  input: (base) => ({ ...base, margin: 0, padding: 0, fontSize: "0.75rem" }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "26px",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 100001 }),
  menu: (base) => ({ ...base, zIndex: 100001, maxHeight: 200, minHeight: 100 }),
  singleValue: (base) => ({
    ...base,
    fontSize: "0.75rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  menuList: (base) => ({
    ...base,
    minHeight: 100,
    maxHeight: 200,
    padding: 0,
    backgroundColor: "white",
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "4px 8px",
    fontSize: "0.75rem",
    backgroundColor: state.isSelected
      ? "#2684FF"
      : state.isFocused
      ? "#F5F5F5"
      : "white",
    color: state.isSelected ? "white" : "black",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
});
